var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"plus"),React.createElement("path",{"d":"M512 292.572h-219.428v219.428h-73.143v-219.428h-219.429v-73.143h219.429v-219.429h73.143v219.429h219.428z","key":1})]);
}

Plus.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = Plus;

Plus.default = Plus;
